<template>
  <div>
    <d-table
      :data_object="data_object"
      :getFreshData="true"
      :rowClick="rowClick"
      :newItemTitle="newItemTitle"
      :addButtonCaption="addButtonCaption"
      :isGoToButton="true"
      goToButtonText="To Portal"
      :goToButtonAction="goToPortal"
    >
    </d-table>
  </div>
</template>
<script>
import DTable from "../components/Table";

export default {
  components: { DTable },
  data() {
    return {
      getFreshData: true,
      newItemTitle: "Add Customer",
      addButtonCaption: "New Customer",
      data_object: {
        object_name: "emover_customers",
        mobileBreakpoint: 0,

        aggregate: {
          local_collection: "emover_customers",
          // foreign_collection: "customer",
          // local_field: "customer_id",
          // foreign_field: "_id",
          name: "emover_customers",
          qry: {},
          select_fields: {
            Company: "$company",
            PortalID: "$portal_id"
          }
        },

        item_key: "customer_id",
        table_title: "Customers",
        hasSearch: true
      }
    };
  },
  methods: {
    rowClick: function(item) {
      // console.log(this.$root);

      const customer = {
        _id: item._id,
        text: "#" + item.Company,
        link: "/emovercustomer/" + item._id
      };
      // var customer_id = customer._id;

      this.$router.push({ path: customer.link });

      // this.$router.push({
      //   name: "emovercustomer",
      //   params: { id: customer_id },
      // });
      // window.location.href = window.location.origin + customer.link;
      // this.$root.addResentTab(item);

      // console.log(item);
    },

    goToPortal: function(item) {
      console.log("GO TO Portal");
      this.$store
        .dispatch("auth/CHANGE_PORTAL", item.PortalID)
        .then(() => this.$router.push("/"));
    }
  }
};
</script>
